'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeLeaderboard = exports.fetchLeaderboard = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _orderBy = require('lodash/orderBy');

var _orderBy2 = _interopRequireDefault(_orderBy);

var _client = require('../../utils/client');

var _justgiving = require('../../utils/justgiving');

var _params = require('../../utils/params');

var _currencies = require('../../utils/currencies');

var _leaderboards = require('../../utils/leaderboards');

var _totals = require('../../utils/totals');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * @function fetches fundraising pages ranked by funds raised
 */
var fetchLeaderboard = function fetchLeaderboard() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  if (params.tagId || params.tagValue) {
    return (0, _leaderboards.fetchLeaderboard)(_extends({}, params, {
      id: (0, _params.getUID)(params.campaign),
      type: 'campaign'
    })).then(function (results) {
      return removeExcludedPages(results, params.excludePageIds);
    });
  }

  if (!(0, _params.isEmpty)(params.campaign) && params.allPages) {
    return recursivelyFetchJGLeaderboard((0, _params.getUID)(params.campaign), params.q, params.limit).then(function (results) {
      return removeExcludedPages(results, params.excludePageIds);
    });
  }

  switch ((0, _params.dataSource)(params)) {
    case 'event':
      if (params.type === 'team') {
        return Promise.reject(new Error('Team leaderboards by event are not supported'));
      }

      return (0, _client.get)('/v1/events/leaderboard', {
        eventid: Array.isArray(params.event) ? params.event.map(_params.getUID) : (0, _params.getUID)(params.event),
        currency: (0, _currencies.currencyCode)(params.country),
        maxResults: params.limit
      }, {}, { paramsSerializer: _params.paramsSerializer }).then(function (response) {
        return response.pages.map(function (page) {
          return _extends({}, page, {
            raisedAmount: page.amount,
            eventName: response.eventName,
            currencyCode: response.currency,
            currencySymbol: (0, _currencies.currencySymbol)(response.currency)
          });
        });
      }).then(function (results) {
        return removeExcludedPages(results, params.excludePageIds);
      });

    default:
      var isTeam = params.type === 'team';
      var maxPerRequest = 20;

      var _params$results = params.results,
          results = _params$results === undefined ? [] : _params$results,
          otherParams = _objectWithoutProperties(params, ['results']);

      return (0, _client.get)('donationsleaderboards/v1/leaderboard', _extends({}, otherParams, {
        currencyCode: (0, _currencies.currencyCode)(params.country)
      }), {
        mappings: {
          campaign: 'campaignGuids',
          charity: 'charityIds',
          excludePageIds: 'excludePageGuids',
          limit: 'take',
          page: 'offset',
          type: 'groupBy'
        },
        transforms: {
          campaign: _params.splitOnDelimiter,
          charity: _params.splitOnDelimiter,
          excludePageIds: _params.splitOnDelimiter,
          limit: function limit(val) {
            return Math.min(maxPerRequest, val || 10);
          },
          page: function page(val) {
            return String(val ? Math.min(maxPerRequest, params.limit || 10) * (val - 1) : 0);
          },
          type: function type(val) {
            return isTeam ? 'TeamGuid' : 'PageGuid';
          }
        }
      }, { paramsSerializer: _params.paramsSerializer }).then(function (response) {
        var _response$meta = response.meta,
            currentPage = _response$meta.currentPage,
            lastRowOnPage = _response$meta.lastRowOnPage,
            pageCount = _response$meta.pageCount;

        var updatedResults = [].concat(_toConsumableArray(results), _toConsumableArray(response.results));

        if (currentPage >= pageCount || lastRowOnPage >= params.limit) {
          return updatedResults;
        }

        return fetchLeaderboard(_extends({}, params, {
          results: updatedResults,
          page: currentPage + 1
        }));
      }).then(function (results) {
        return filterLeaderboardResults(results, isTeam);
      }).then(function (results) {
        return mapLeaderboardResults(results, isTeam);
      }).then(function (results) {
        return removeExcludedPages(results, params.excludePageIds);
      }).then(function (results) {
        return rankLeaderboardResults(results, isTeam);
      });
  }
};

exports.fetchLeaderboard = fetchLeaderboard;
var rankLeaderboardResults = function rankLeaderboardResults() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isTeam = arguments[1];

  return (0, _orderBy2.default)(results, ['donationAmount'], ['desc']);
};

var filterLeaderboardResults = function filterLeaderboardResults() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isTeam = arguments[1];

  return results.filter(function (result) {
    return isTeam ? result.team : result.page;
  });
};

var removeExcludedPages = function removeExcludedPages() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var pageIds = arguments[1];

  if (!pageIds) return results;

  var identifierKeys = ['eventGivingGroupId', 'legacyId', 'pageGuid', 'pageShortName', 'shortName', 'slug', 'tagValue'];

  return results.filter(function (page) {
    return identifierKeys.reduce(function (current, key) {
      if (!page[key]) return current;
      return current ? pageIds.indexOf(page[key].toString()) < 0 : false;
    }, true);
  });
};

var mapLeaderboardResults = function mapLeaderboardResults() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isTeam = arguments[1];

  return results.map(function (result) {
    return isTeam ? _extends({}, result, result.team, {
      currencyCode: (0, _get2.default)(result.team, 'fundraisingConfiguration.currencyCode'),
      donationAmount: (0, _get2.default)(result, 'team.donationSummary.totalAmount') || result.donationAmount,
      eventName: [result.team.captain.firstName, result.team.captain.lastName].join(' '),
      numberOfSupporters: result.team.numberOfSupporters,
      pageId: result.id,
      pageImages: [result.team.coverImageName],
      pageShortName: result.team.shortName,
      target: (0, _get2.default)(result.team, 'fundraisingConfiguration.targetAmount'),
      type: 'team'
    }) : _extends({}, result, result.page, {
      donationAmount: (0, _get2.default)(result, 'page.raisedAmount') || result.donationAmount,
      eventName: [result.page.owner.firstName, result.page.owner.lastName].join(' '),
      pageImages: [result.page.photo],
      pageShortName: result.page.shortName,
      numberOfSupporters: result.donationCount,
      type: 'individual'
    });
  });
};

var recursivelyFetchJGLeaderboard = function recursivelyFetchJGLeaderboard(campaign, q) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var results = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

  var options = {
    params: { page: page, q: q }
  };

  return _client.servicesAPI.get('/v1/justgiving/campaigns/' + campaign + '/pages', options).then(function (response) {
    return response.data;
  }).then(function (data) {
    var _data$meta = data.meta,
        currentPage = _data$meta.currentPage,
        totalPages = _data$meta.totalPages;

    var updatedResults = [].concat(_toConsumableArray(results), _toConsumableArray(data.results));

    if (currentPage === totalPages || page * 10 >= limit) {
      return updatedResults;
    } else {
      return recursivelyFetchJGLeaderboard(campaign, q, limit, updatedResults, page + 1);
    }
  });
};

/**
 * @function a default deserializer for leaderboard pages
 */
var deserializeLeaderboard = exports.deserializeLeaderboard = function deserializeLeaderboard(supporter, index) {
  var isTeam = supporter.type === 'team';
  var slug = supporter.pageShortName || supporter.shortName || supporter.slug;
  var owner = (0, _get2.default)(supporter, 'pageOwner.fullName') || (0, _get2.default)(supporter, 'owner.firstName') ? [supporter.owner.firstName, supporter.owner.lastName].join(' ') : null;

  return {
    currency: supporter.currencyCode || (0, _get2.default)(supporter, 'donationSummary.totalAmount.currencyCode'),
    currencySymbol: supporter.currencySymbol,
    donationUrl: isTeam ? null : (0, _justgiving.baseUrl)() + '/fundraising/' + slug + '/donate',
    id: supporter.pageId || supporter.legacyId,
    image: (0, _get2.default)(supporter, 'heroMedia.url') ? (0, _get2.default)(supporter, 'heroMedia.url') + '?template=Size186x186Crop' : supporter.defaultImage || (0, _justgiving.imageUrl)((0, _get2.default)(supporter, 'pageImages[0]'), 'Size186x186Crop') || (0, _justgiving.imageUrl)(supporter.photo, 'Size186x186Crop') || (isTeam ? 'https://assets.blackbaud-sites.com/images/supporticon/user.svg' : (0, _justgiving.apiImageUrl)(slug, 'Size186x186Crop')),
    name: supporter.pageTitle || supporter.name || supporter.title || supporter.tagValue || (0, _get2.default)(supporter, 'pageOwner.fullName'),
    offline: parseFloat(supporter.totalRaisedOffline || supporter.raisedOfflineAmount || (0, _totals.getMonetaryValue)((0, _get2.default)(supporter, 'donationSummary.offlineAmount'))),
    owner: owner,
    position: index + 1,
    raised: parseFloat((0, _get2.default)(supporter, 'team.donationSummary.totalAmount') || supporter.donationAmount || supporter.amount || supporter.raisedAmount || supporter.amountRaised || (0, _totals.getMonetaryValue)((0, _get2.default)(supporter, 'donationSummary.totalAmount')) || (0, _get2.default)(supporter, 'amounts[8].value', 0) || 0),
    slug: slug,
    status: (0, _get2.default)(supporter, 'page.status') || supporter.status,
    subtitle: owner || supporter.eventName || (0, _get2.default)(supporter, 'owner.name'),
    target: supporter.targetAmount || supporter.target || (0, _totals.getMonetaryValue)((0, _get2.default)(supporter, 'targetWithCurrency')),
    totalDonations: supporter.numberOfSupporters || supporter.donationCount || (0, _get2.default)(supporter, 'donationSummary.donationCount'),
    url: supporter.url || [(0, _justgiving.baseUrl)(), isTeam ? 'team' : 'fundraising', slug].join('/')
  };
};